/**
 * Модуль для рендеринга карточек существ
 */

/**
 * Создаёт менеджер для рендеринга карточек существ
 */
export function createCreatureCardsRenderer({
  escapeHtml,
  renderProfessionBadge,
}) {
  /**
   * Рендерит карточку существа для превью коллекции
   */
  function renderCollectionPreviewCard(creature) {
    const card = document.createElement("div");
    card.className = "creature-card--preview";

    const rarity = (creature.rarity || "").toLowerCase() || "common";
    const rarityLabels = {
      common: "Обычный",
      rare: "Редкий",
      epic: "Эпический",
      legendary: "Легендарный",
    };
    const name = escapeHtml(creature.name || creature.creature_name || "Существо");
    const imageUrl = escapeHtml(
      creature.imageUrl || creature.creature_image || "/creatures/1.png",
    );
    const level = creature.level || 0;
    const profession = creature.profession || creature.profession_id || null;
    const professionLevel =
      creature.profession_level || creature.professionLevel || 0;
    const professionBadge = profession
      ? renderProfessionBadge(profession, professionLevel, { benefitsCount: 1 })
      : "";

    card.innerHTML = `
      <div class="creature-img"><img src="${imageUrl}" style="width: 100%; height: 100%; object-fit: contain;" onerror="this.parentElement.textContent='🐾'; this.remove();"></div>
      <div class="creature-name">${name}</div>
      <div class="creature-meta">${rarityLabels[rarity] || rarity}${level ? ` • Ур. ${level}` : ""}</div>
      ${professionBadge}
    `;

    return card;
  }

  /**
   * Рендерит карточку существа для магазина/коллекции
   */
  function renderCreatureCard(creature, isStoreItem = false) {
    const card = document.createElement("div");
    card.className = "creature-card";

    const rarity = (creature.rarity || "").toLowerCase() || "common";
    const rarityLabels = {
      common: "Обычный",
      rare: "Редкий",
      epic: "Эпический",
      legendary: "Легендарный",
    };
    const name = escapeHtml(creature.name || creature.creature_name || "");
    const imageUrl = escapeHtml(
      creature.imageUrl || creature.creature_image || "/creatures/1.png",
    );
    const level = creature.level || 0;
    const exp = creature.exp || 0;
    const priceStars = creature.priceStars || creature.price_stars || 0;
    const profession = isStoreItem
      ? null
      : creature.profession || creature.profession_id || null;
    const professionLevel = creature.profession_level || creature.professionLevel || 0;
    const professionBadge =
      !isStoreItem && profession
        ? renderProfessionBadge(profession, professionLevel, { benefitsCount: 1 })
        : "";

    card.innerHTML = `
      <div class="creature-img"><img src="${imageUrl}" style="width: 100%; height: 100%; object-fit: contain;" onerror="this.parentElement.textContent='🐾'; this.remove();"></div>
      <div class="creature-name">${name}</div>
      ${level ? `<div style="font-size: 12px; color: var(--tg-theme-hint-color);">Уровень ${level} (${exp}/100)</div>` : ""}
      <div class="rarity-badge rarity-${rarity}">${escapeHtml(rarityLabels[rarity] || rarity)}</div>
      ${professionBadge}
      ${isStoreItem ? `<div class="creature-price">${priceStars} ⭐</div>` : ""}
    `;

    return card;
  }

  return {
    renderCollectionPreviewCard,
    renderCreatureCard,
  };
}









